import useExploreInfo from "Hooks/useExploreInfo";
import styles from "./ConceptAcademicInformation.module.scss";
import { getConceptTopInstitutionsByID } from "Explore/Services/Concept";
import {
  InstitutionCard,
  LoadingListEntityProfile,
  PaginationList,
} from "Explore/Components";
import { Empty } from "antd";
import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { Grid } from "@mui/material";

const ConceptInstitutionList = () => {
  const { entity_id: conceptId } = useExploreInfo();
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 12,
    totalRows: 0,
  });

  const prevFilter = useRef({});

  useEffect(() => {
    const _prevFilter = prevFilter.current;
    if (
      !_.isEqual(_prevFilter, {
        conceptId,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
      })
    ) {
      let newPagination = { ...pagination };
      if (
        _prevFilter.conceptId !== conceptId ||
        _prevFilter.rowsPerPage !== pagination.rowsPerPage
      ) {
        newPagination.page = 1;
      }

      setData({ data: [], isLoading: true });
      getConceptTopInstitutionsByID({
        id: conceptId,
        page: newPagination.page - 1,
        rowsPerPage: newPagination.rowsPerPage,
      })
        .then((res) => {
          setData({ data: res.results, isLoading: false });
          setPagination({ ...newPagination, totalRows: res.total_count });
        })
        .catch((err) => {
          setData({ data: [], isLoading: false });
          setPagination({ ...newPagination, totalRows: 0 });
        })
        .finally(() => {
          prevFilter.current = {
            conceptId,
            page: newPagination.page,
            rowsPerPage: newPagination.rowsPerPage,
          };
        });
    } else {
      prevFilter.current = {
        conceptId,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
      };
    }
  }, [conceptId, pagination.page, pagination.rowsPerPage]);
  return (
    <div className={styles["list__wrapper"]}>
      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data.data.length > 0 ? (
            <Grid container spacing="25px">
              {data.data.map((e, i) => (
                <Grid item xs={12} key={i}>
                  <InstitutionCard
                    data={{
                      ...e,
                      ...e.specific_stats,
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Empty description="No Institution Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />

      <PaginationList
        pagination={pagination}
        setPagination={setPagination}
        pageSizeOptions={[12, 36, 48, 60]}
      />
    </div>
  );
};

export default ConceptInstitutionList;
